import { Pagination } from 'antd';
import { Component } from 'react';

import s from './PagePagination.module.scss';

class PagePagination extends Component {
	render() {
		const { currentPage, totalItems, onPageChange, searchQuery, mobile } = this.props;

		return (
			<div className={s.pagination}>
				<Pagination
					size={mobile ? 'small' : 'default'}
					total={totalItems}
					current={currentPage}
					showSizeChanger={false}
					onChange={(page) => onPageChange(page, searchQuery)}
					hideOnSinglePage={true}
					defaultPageSize={20}
				/>
			</div>
		);
	}
}

export default PagePagination;
